import * as types from './mutation-types'

export const wedgeUserAdd = ({ commit }, user) => {
  commit(types.WEDGEUSER_ADD, user)
}



// WEBPACK FOOTER //
// ./src/store/actions.js